if (!customElements.get('shopix-sort-select')) {
  class ShopixSortSelect extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.trigger = this.querySelector('.mobile-facets__sort-trigger');
      this.menu = this.querySelector('.mobile-facets__sort-options');
      this.valueLabel = this.querySelector('.mobile-facets__sort-value');
      this.select = this.querySelector('.mobile-facets__native-sort');
      this.options = Array.from(this.querySelectorAll('.mobile-facets__sort-option'));

      if (!this.trigger || !this.menu || !this.valueLabel || !this.select) return;

      this.onTriggerClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleMenu();
      };

      this.onTriggerKeydown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleMenu();
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.openMenu();
          this.focusSelectedOption();
        } else if (event.key === 'Escape') {
          this.closeMenu();
        }
      };

      this.onFocusOut = () => {
        window.setTimeout(() => {
          if (!this.contains(document.activeElement)) this.closeMenu();
        });
      };

      this.trigger.addEventListener('click', this.onTriggerClick);
      this.trigger.addEventListener('keydown', this.onTriggerKeydown);
      this.addEventListener('focusout', this.onFocusOut);

      this.options.forEach((option, index) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.selectOption(option);
        });

        option.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.selectOption(option);
          } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const direction = event.key === 'ArrowDown' ? 1 : -1;
            const nextIndex = (index + direction + this.options.length) % this.options.length;
            this.options[nextIndex].focus();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            this.closeMenu(true);
          }
        });
      });
    }

    disconnectedCallback() {
      if (!this.initialized || !this.trigger) return;
      this.trigger.removeEventListener('click', this.onTriggerClick);
      this.trigger.removeEventListener('keydown', this.onTriggerKeydown);
      this.removeEventListener('focusout', this.onFocusOut);
    }

    toggleMenu() {
      this.menu.hidden ? this.openMenu() : this.closeMenu();
    }

    openMenu() {
      this.menu.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
    }

    closeMenu(restoreFocus = false) {
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      if (restoreFocus) this.trigger.focus();
    }

    focusSelectedOption() {
      const selectedOption = this.options.find((option) => option.getAttribute('aria-selected') === 'true');
      (selectedOption || this.options[0])?.focus();
    }

    selectOption(option) {
      const value = option.dataset.value;
      if (typeof value === 'undefined') return;

      this.select.value = value;
      this.valueLabel.textContent = option.querySelector('span')?.textContent?.trim() || '';

      this.options.forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });

      this.closeMenu(true);
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  customElements.define('shopix-sort-select', ShopixSortSelect);
}
